import { render, staticRenderFns } from "./trocas-e-devolucoes.vue?vue&type=template&id=5c3dbbab&"
import script from "./trocas-e-devolucoes.vue?vue&type=script&lang=js&"
export * from "./trocas-e-devolucoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports